import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { WhatsAppState } from "./types";

const getters: GetterTree<WhatsAppState, RootState> = {};

export default getters;
